module.exports = __webpack_public_path__ + "img/如何新建自由节点.c3663e7a.gif";